export { SwapPage as default } from './swap';
